mutation TagGeometryType(
    $delete: Boolean
    $id: ID!
    $revisionID: ID!
    $tag: String!
) {
    tagGeometryTypeRevision(
        delete: $delete
        id: $id
        revisionID: $revisionID
        tag: $tag
    ) {
        errors {
            message
        }
        geometryTypeRevision {
            id
        }
    }
}
